export default function scrollTo(element: Element | null, middle?: boolean): Promise<any> {
  return new Promise((resolve, reject) => {
    if (element) {
      try {
        let middlePos = 0;
        const elementRect = element.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;

        if (middle !== false) {
          middlePos = absoluteElementTop - window.innerHeight / 2;
        }

        const top = middlePos ? middlePos : absoluteElementTop;

        $("html, body").animate(
          {
            scrollTop: top
          },
          500,
          () => {
            resolve();
          }
        );
      } catch (error) {
        reject(error);
      }
    } else {
      resolve();
    }
  });
}
